import { ClienteAnaliseMercadoProjecaoSearch } from './cliente-analise-mercado-projecao-search';
import { ClienteAnaliseMercadoProjecaoClassificacaoSave } from './classificacao';

export class ClienteAnaliseMercadoProjecaoSave {
    idClienteAnaliseMercado: number;
    idCliente: number;
    mes: number;
    ano: number;
    classificacoes: ClienteAnaliseMercadoProjecaoClassificacaoSave[] = [];

    /** Se deve carregar as projeções dos lançamentos das classificações após salvá-las */
    loadClassificacoesAfterSave: boolean;
    perspectivaAfterSave: number;

    /** Se deve pesquisar as projeções do cliente após salvá-las */
    searchProjecoesClientesAfterSave: boolean;
    /** Projeções salvas do cliente quando informado que deve pesquisá-las após salvá-las */
    projecoesCliente: ClienteAnaliseMercadoProjecaoSearch[];

    /**
     * Cria um novo objeto para salvar as projeções de vendas mensais das classificações do cliente nas análises de mercados
     *
     * @param idCliente ID do cliente
     * @param mes Mês das projeções
     * @param ano Ano das projeções
     * @param classificacoes Projeções de vendas das classificações a serem salvas
     */
    constructor(idClienteAnaliseMercado: number, idCliente: number, mes: number, ano: number, classificacoes: ClienteAnaliseMercadoProjecaoClassificacaoSave[] = []) {
        this.idClienteAnaliseMercado = idClienteAnaliseMercado;
        this.idCliente = idCliente;
        this.mes = mes;
        this.ano = ano;
        this.classificacoes = classificacoes;
    }
}
